export const PERMISSIONS = {
  // Franchise
  company: 'company',
  company_view: 'company_view',
  company_create: 'company_create',
  company_edit: 'company_edit',
  company_delete: 'company_delete',

  // Project
  project: 'project',
  project_view: 'project_view',
  project_create: 'project_create',
  project_edit: 'project_edit',
  project_delete: 'project_delete',
  // Project Task
  projectTask: 'projectTask',
  projectTask_view: 'projectTask_view',
  projectTask_create: 'projectTask_create',
  projectTask_edit: 'projectTask_edit',
  projectTask_delete: 'projectTask_delete',
  // Project Estimate
  projectEstimate: 'projectEstimate',
  projectEstimate_view: 'projectEstimate_view',
  projectEstimate_create: 'projectEstimate_create',
  projectEstimate_edit: 'projectEstimate_edit',
  projectEstimate_delete: 'projectEstimate_delete',
  projectEstimate_esign: 'projectEstimate_esign',
  // Project Note
  projectNote: 'projectNote',
  projectNote_view: 'projectNote_view',
  projectNote_create: 'projectNote_create',
  projectNote_edit: 'projectNote_edit',
  projectNote_delete: 'projectNote_delete',
  // Project Activity
  projectActivity: 'projectActivity',
  projectActivity_view: 'projectActivity_view',
  // Project File manage
  projectFile: 'projectFile',
  projectFile_view: 'projectFile_view',
  projectFile_create: 'projectFile_create',
  projectFile_edit: 'projectFile_edit',
  projectFile_delete: 'projectFile_delete',
  projectFile_report: 'projectFile_report',
  // Project File Financial
  projectFinancial: 'projectFinancial',
  projectFinancial_view: 'projectFinancial_view',
  invoice: 'invoice',
  invoice_view: 'invoice_view',
  invoice_create: 'invoice_create',
  invoice_edit: 'invoice_edit',
  invoice_delete: 'invoice_delete',
  invoice_sync: 'invoice_sync',
  invoice_reminder: 'invoice_reminder',
  // COGS
  cogs: 'cogs',
  cogs_view: 'cogs_view',
  cogs_create: 'cogs_create',
  cogs_edit: 'cogs_edit',
  cogs_delete: 'cogs_delete',

  // Project areascope
  projectAreaScope: 'projectAreaScope',
  projectAreaScope_view: 'projectAreaScope_view',
  projectAreaScope_create: 'projectAreaScope_create',
  projectAreaScope_edit: 'projectAreaScope_edit',
  projectAreaScope_delete: 'projectAreaScope_delete',

  // Account
  account: 'account',
  account_view: 'account_view',
  account_create: 'account_create',
  account_edit: 'account_edit',
  account_delete: 'account_delete',

  // Schedule
  schedule: 'schedule',
  schedule_view: 'schedule_view',
  schedule_create: 'schedule_create',
  schedule_edit: 'schedule_edit',
  schedule_delete: 'schedule_delete',

  // job type
  jobType: 'jobType',
  jobType_view: 'jobType_view',
  jobType_create: 'jobType_create',
  jobType_edit: 'jobType_edit',
  jobType_delete: 'jobType_delete',

  // Organization
  organization: 'organization',
  organization_view: 'organization_view',
  organization_create: 'organization_create',
  organization_edit: 'organization_edit',
  organization_delete: 'organization_delete',
  // Organization Task
  organizationTask: 'organizationTask',
  organizationTask_view: 'organizationTask_view',
  organizationTask_create: 'organizationTask_create',
  organizationTask_edit: 'organizationTask_edit',
  organizationTask_delete: 'organizationTask_delete',

  // Organization Note
  organizationNote: 'organizationNote',
  organizationNote_view: 'organizationNote_view',
  organizationNote_create: 'organizationNote_create',
  organizationNote_edit: 'organizationNote_edit',
  organizationNote_delete: 'organizationNote_delete',
  // Organization Activity
  organizationActivity: 'organizationActivity',
  organizationActivity_view: 'organizationActivity_view',
  // Organization File
  organizationFile: 'organizationFile',
  organizationFile_view: 'organizationFile_view',
  organizationFile_create: 'organizationFile_create',
  organizationFile_edit: 'organizationFile_edit',
  organizationFile_delete: 'organizationFile_delete',

  // Contact
  contact: 'contact',
  contact_view: 'contact_view',
  contact_create: 'contact_create',
  contact_edit: 'contact_edit',
  contact_delete: 'contact_delete',
  // Contact Task
  contactTask: 'contactTask',
  contactTask_view: 'contactTask_view',
  contactTask_create: 'contactTask_create',
  contactTask_edit: 'contactTask_edit',
  contactTask_delete: 'contactTask_delete',
  contactTask_reminder: 'contactTask_reminder',
  // Contact Note
  contactNote: 'contactNote',
  contactNote_view: 'contactNote_view',
  contactNote_create: 'contactNote_create',
  contactNote_edit: 'contactNote_edit',
  contactNote_delete: 'contactNote_delete',
  // Contact Activity
  contactActivity: 'contactActivity',
  contactActivity_view: 'contactActivity_view',
  // Contact File
  contactFile: 'contactFile',
  contactFile_view: 'contactFile_view',
  contactFile_create: 'contactFile_create',
  contactFile_edit: 'contactFile_edit',
  contactFile_delete: 'contactFile_delete',

  // CRM
  crm: 'crm',
  crm_view: 'crm_view',
  crm_edit: 'crm_edit',
  crm_call: 'crm_call',
  crm_message: 'crm_message',

  // Time Clock
  timeClock: 'timeClock',
  timeClock_view: 'timeClock_view',
  timeClock_viewAll: 'timeClock_viewAll',
  timeClock_create: 'timeClock_create',
  timeClock_edit: 'timeClock_edit',
  timeClock_delete: 'timeClock_delete',
  timeClock_export: 'timeClock_export',

  // Price
  price: 'price',
  price_view: 'price_view',
  price_create: 'price_create',
  price_edit: 'price_edit',
  price_delete: 'price_delete',
  // Price Component
  priceComponent: 'priceComponent',
  priceComponent_view: 'priceComponent_view',
  priceComponent_create: 'priceComponent_create',
  priceComponent_edit: 'priceComponent_edit',
  priceComponent_delete: 'priceComponent_delete',
  // Price Item
  priceItem: 'priceItem',
  priceItem_view: 'priceItem_view',
  priceItem_create: 'priceItem_create',
  priceItem_edit: 'priceItem_edit',
  priceItem_delete: 'priceItem_delete',

  // Report
  report: 'report',
  report_view: 'report_view',

  // Estimate Template
  template: 'template',
  estimateTemplate: 'estimateTemplate',
  estimateTemplate_view: 'estimateTemplate_view',
  estimateTemplate_create: 'estimateTemplate_create',
  estimateTemplate_edit: 'estimateTemplate_edit',
  estimateTemplate_delete: 'estimateTemplate_delete',

  // Opening Statement Template
  openingStatementTemplate: 'openingStatementTemplate',
  openingStatementTemplate_view: 'openingStatementTemplate_view',
  openingStatementTemplate_create: 'openingStatementTemplate_create',
  openingStatementTemplate_edit: 'openingStatementTemplate_edit',
  openingStatementTemplate_delete: 'openingStatementTemplate_delete',
  // Estimate Term Template
  estimateTermTemplate: 'estimateTermTemplate',
  estimateTermTemplate_view: 'estimateTermTemplate_view',
  estimateTermTemplate_create: 'estimateTermTemplate_create',
  estimateTermTemplate_edit: 'estimateTermTemplate_edit',
  estimateTermTemplate_delete: 'estimateTermTemplate_delete',
  // Email Template
  emailTemplate: 'emailTemplate',
  emailTemplate_view: 'emailTemplate_view',
  emailTemplate_create: 'emailTemplate_create',
  emailTemplate_edit: 'emailTemplate_edit',
  emailTemplate_delete: 'emailTemplate_delete',

  setting: 'setting',
  // Quickbook
  quickbooks: 'quickbooks',
  quickbooks_connect: 'quickbooks_connect',
  quickbooks_view: 'quickbooks_view',

  // Ringcentral
  ringCentral: 'ringCentral',
  ringCentral_connect: 'ringCentral_connect',

  send_email: 'send_email',

  // Location Company
  location: 'location',
  location_view: 'location_view',
  location_create: 'location_create',
  location_edit: 'location_edit',
  location_delete: 'location_delete',

  // Company Role
  companyRole: 'companyRole',
  companyRole_view: 'companyRole_view',
  companyRole_create: 'companyRole_create',
  companyRole_edit: 'companyRole_edit',
  companyRole_delete: 'companyRole_delete',

  // Company Task
  companyTask: 'companyTask',
  companyTask_view: 'companyTask_view',
  companyTask_create: 'companyTask_create',
  companyTask_edit: 'companyTask_edit',
  companyTask_delete: 'companyTask_delete',

  // Equipment
  equipment: 'equipment',
  equipment_view: 'equipment_view',
  equipment_create: 'equipment_create',
  equipment_edit: 'equipment_edit',
  equipment_delete: 'equipment_delete',

  // Project status
  projectStatus: 'projectStatus',
  projectStatus_view: 'projectStatus_view',
  projectStatus_create: 'projectStatus_create',
  projectStatus_edit: 'projectStatus_edit',
  projectStatus_delete: 'projectStatus_delete',

  // Project status
  crmStatus: 'crmStatus',
  crmStatus_view: 'crmStatus_view',
  crmStatus_create: 'crmStatus_create',
  crmStatus_edit: 'crmStatus_edit',
  crmStatus_delete: 'crmStatus_delete',

  // Auth
  auth: 'auth',
  auth_edit: 'auth_edit',
  auth_setting: 'auth_setting',

  // Campaign status
  campaign: 'campaign',
  campaign_view: 'campaign_view',
  campaign_create: 'campaign_create',
  campaign_edit: 'campaign_edit',
  campaign_delete: 'campaign_delete',

  crmStatusSetting: 'crmStatusSetting',
  crmStatusSetting_view: 'crmStatusSetting_view',
  crmStatusSetting_create: 'crmStatusSetting_create',
  crmStatusSetting_edit: 'crmStatusSetting_edit',
  crmStatusSetting_delete: 'crmStatusSetting_delete',
};
